import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          className="prefix__st0"
          d="M17.1 2.5v3.3l-2-2c-.4.3-.8.6-1.1.9-3.1 3.1-2.7 5.7-1.6 6.8l-3.3 3.3v2.3l4.8-4.8c1.3.3 3.2-.2 5.3-2.4C22.4 6.8 24 0 24 0s-3.7.8-6.9 2.5z"
          fill="currentColor"
        />
        <path
          className="prefix__st0"
          d="M14.8 14.7l-6 6c-.2.2-.5.3-.8.3-.1 0-.3 0-.4-.1-.4-.2-.7-.6-.7-1.1v-5.5c0-.3.1-.6.3-.8l2.4-2.4c-.5-1.3-.4-2.7.2-4.2H2.3C1 6.9 0 7.9 0 9.1v12.6C0 23 1 24 2.3 24h12.6c1.3 0 2.3-1 2.3-2.3v-7.5c-.9.3-1.7.5-2.4.5z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default SvgComponent;
